export function extract (json) {
  if (Array.isArray(json.data)) {
    var data = []
    json.data.forEach((v) => {
      data.push(extract({data: v}))
    })
  } else {
    var data = {}
    for (let p in json.data) {
      if (json.data.hasOwnProperty(p)) {
        if (json.data[p] && typeof json.data[p] === 'object' && json.data[p].hasOwnProperty('data')) {
          data[p] = extract(json.data[p])
        } else {
          data[p] = json.data[p]
        }
      }
    }
  }
  return data
}